<div class="m-portlet m-portlet--mobile m-portlet--body-progress-">
	<div class="m-portlet__head">
		<div class="m-portlet__head-caption">
			<div class="m-portlet__head-title">
				<h3 class="m-portlet__head-text">
					Bio-Metric Attendance- <small> {{batchId}}</small>&nbsp;&nbsp;
				</h3>
			</div>
		</div>
		<div class="m-portlet__head-tools">
			<button (click)="goBack()" type="button"
				class="btn btn-secondary m-btn m-btn--custom m-btn--outline-2x button-round">
				Back
			</button>
		</div>
	</div>
	<!-- <div class="m-portlet__head"> -->

	<!-- <div class="m-portlet__body1 form-group m-form__group row">
      <div class="col-12 col-sm-8 col-xl-8 col-md-8">
        <h4 class="m-portlet__head-text">
          Bio-Metric Attendance- <small> {{batchId}}</small>&nbsp;&nbsp;
        </h4>
      </div>
      <div class="col-12 col-sm-4 col-xl-4 col-md-4" style="text-align: right;">
					<button (click)="goBack()" type="button" class="btn btn-secondary m-btn m-btn--custom m-btn--outline-2x button-round">
						Back
					</button>
      </div>
    </div> -->
	<!-- </div> -->
	<hr>
	<div class="m-portlet m-portlet--mobile">
		<ul class="nav nav-pills nav-fill" role="tablist">
			<li class="nav-item">
				<a class="nav-link active" (click)="setTab('candidate')" data-toggle="tab"
					href="#m_tabs_3_1"
					role="tab">
					Candidate Wise</a>
			</li>
			<li class="nav-item">
				<a (click)="setTab('batch')" class="nav-link" data-toggle="tab"
					href="#m_tabs_3_2" role="tab">
					Batch Wise</a>
			</li>
		</ul>
		<div class="tab-content">
			<div class="tab-pane active" show id="m_tabs_3_1" role="tabpanel">
				<div class="col-md-12">
					<div class="row" style="margin-top: 19px;">

						<div class="col-md-2">
							<label>
								<b>Candidate Id</b>
							</label>
							<input type="text" class="form-control m-input m-input--solid"
								[(ngModel)]="modelObj.candidateId" placeholder="Enter candidate ID"
								id="generalSearch">
						</div>

						<div class="col-md-2">
							<label>
								<b>Attendance Status</b>
							</label>
							<select class="form-control selectcolor"
								[(ngModel)]="modelObj.attendenceStatus"
								id="m_select2_1" name="param">
								<option value disabled selected>All</option>
								<option value="P">Present</option>
								<option value="A">Absent</option>

							</select>
						</div>

						<div class="col-md-2">
							<label>
								<br> </label>
							<div>
								<button type="button" class="btn btn-brand"
									style="background:#ef7e22;color:white;"
									(click)="applyFilter()">Search</button>
								<button type="button" class="btn btn-secondary" (click)="reset()">
									Reset
								</button>
							</div>
						</div>
						<br>
					</div>
					<br>
					<br>
					<div *ngIf="batchAttendenceArray.length > 0" class="row table-responsive"
						style="margin-top : 30px;height: 500px;overflow: scroll;">
						<table class="notranslate table table-striped m-table">
							<thead class="m-datatable__head">
								<tr class="m-datatable__row">
									<th><b>Sl.No</b></th>
									<th>
										<b>Name of Applicants</b>
									</th>
									<th>
										<b>Candidate ID</b>
									</th>
									<th>
										<b>Total Training Hours</b>
									</th>
									<th>
										<b>Total Attended Hours</b>
									</th>
									<th>
										<b>Total Attendance Percentage</b>
									</th>
									<th>
										<b>Status</b>
									</th>
									<th>
										<b>Action</b>
									</th>
									<!-- <th>
                    <b>Percentage</b>
				  </th> -->
									<!-- <ng-container *ngIf="dateArray.length !== 0">
										<th *ngFor="let date of dateArray[0].attendence;">
											<b>{{date.date | date}}</b>
										</th>
									</ng-container>
									<ng-container *ngIf="dateArray.length === 0">
										<th *ngFor="let date of batchAttendenceArray[0].attendence;">
											<b>{{date.date | date}}</b>
										</th>
									</ng-container> -->

								</tr>
							</thead>
							<tbody class="notranslate">
								<tr *ngFor="let applicant of batchAttendenceArray; let i=index;">
									<td>{{i+1}}</td>
									<td>{{applicant?.candiateName ? applicant?.candiateName : 'N/A'}}</td>
									<td>{{applicant?.candidateId ? applicant?.candidateId : 'N/A'}}</td>
									<!-- changes for the hourly based attendace start -->
									<td>{{batchData && batchData.schemeType && batchData.schemeType == 'RPL' ?  batchData?.totalNoOfTrainingHrs :
										batchData.jobRoles[0].overrideQpHours ? batchData.jobRoles[0].overrideQpHours : 0}}</td>
									<td>{{applicant?.totalEligibleCandidateHours ?
										applicant?.totalEligibleCandidateHours : 0}}</td>
									<td>{{applicant?.totalEligibleCandidateHoursPercentage ?
										applicant?.totalEligibleCandidateHoursPercentage : 0}}%</td>
									<td><span
											[style.color]="statusColor[applicant.status?applicant.status: '']"><b>{{applicant.status
												? applicant.status:
												'N/A'}}</b></span>
									</td>

									<td class="m-datatable__cell">
										<span
											style="overflow: visible; width: 110px">
											<div class="dropdown">
												<a
													href="#"
													class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
													data-toggle="dropdown">
													<i class="la la-ellipsis-h"></i>
												</a>
												<div
													class="dropdown-menu dropdown-menu-right">
													<div>
														<a
															class="dropdown-item"
															(click)="
															openAttendanceModal(
																applicant
															)
														">
															View Attendance
														</a>
													</div>
												</div>
											</div>
										</span>
									</td>
									<!-- <td>{{applicant.percentage?applicant.percentage: ''}}</td> -->
									<!-- <td *ngFor="let attendace of applicant.attendence; let j=index;">
										<span
											[style.color]="statusColor[attendace.attendenceStatus?attendace.attendenceStatus: '-']">
											<b>{{attendace.attendenceStatus ? attendace.attendenceStatus:"N/A"}}</b></span><span
											*ngIf="attendace && attendace.attendenceStatus">/<b>{{attendace.eligibleCandidatePerDayDuration
												? attendace.eligibleCandidatePerDayDuration : 0}}</b></span>
									</td> -->
									<!-- changes for the hourly based attendace start -->
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="tab-pane" id="m_tabs_3_2" role="tabpanel">
				<div class="col-md-12">
					<div class="row" style="margin-top: 19px;">

						<!-- <div class="col-md-2">
              <label>
                <b>Candidate Id</b>
              </label>
              <input type="text" class="form-control m-input m-input--solid" [(ngModel)]="modelObj.candidateId"
                placeholder="Enter candidate ID" id="generalSearch">
            </div>

            <div class="col-md-2">
              <label>
                <b>Attendance Status</b>
              </label>
              <select class="form-control selectcolor" [(ngModel)]="modelObj.attendenceStatus" id="m_select2_1"
                name="param">
                <option value="" disabled selected>All</option>
                <option value="P">Present</option>
                <option value="A">Absent</option>

              </select>
            </div>

            <div class="col-md-2">
              <label>
                <br> </label>
              <div>
                <button type="button" class="btn btn-brand" style="background:#ef7e22;color:white;"
                  (click)="applyFilter()">Search</button>
                <button type="button" class="btn btn-secondary" (click)="reset()">
                  Reset
                </button>
              </div>
            </div> -->
						<br>
					</div>
					<br>
					<br>
					<div
						class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
						id="scrolling_horizontal" style="position: static; zoom: 1;">
						<table class="table table-striped">
							<tr>
								<th>
									<strong>Batch ID</strong>
								</th>
								<th>
									<strong>Total Candidate Count</strong>
								</th>
								<th>
									<strong>Total Present Count</strong>
								</th>
								<th>
									<strong>Absent Count</strong>
								</th>
								<th>
									<strong>Batch Current Percentage</strong>
								</th>
								<th>
									<strong>Attendance Date</strong>
								</th>

							</tr>
							<tr *ngFor="let att of attendanceData">
								<td>{{att.batchId}}</td>
								<td>{{att.totalCandidateCount ? att.totalCandidateCount : 'N/A'}}</td>
								<td>{{getData(att)}}</td>
								<td>{{att.totalCandidateCount - att.totalPresentCount}}</td>
								<td>{{att.batchCurrentPercent}}</td>
								<td>{{att.attendanceDate | date}}</td>
								<!-- <td><span [style.color]="statusColor[att.attendenceStatus]">{{att.attendenceStatus}}</span></td> -->

							</tr>
							<tr *ngIf="attendanceData.length === 0" style="color:grey;font-size:17px">
								<td colspan="8">
									<p style="text-align:center;">No Attendance Found</p>
								</td>
							</tr>
						</table>
					</div>
					<div *ngIf="count > 9">
						<app-pagination [count]=count (pageNumber)="assignPageNo($event)"
							(recordsPerPage)="assignRecordsPerPage($event)">
						</app-pagination>
					</div>
				</div>
			</div>
		</div>

	</div>
</div>

<div class="modal show" id="candidate-attendance" tabindex="-1" role="dialog"
	style="padding-right: 17px;">
	<div class="modal-dialog modal-lg" style="max-width: 1000px !important;" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Candidate Attendance</h5>
				<button type="button" class="close" (click)="closeAttendanceModal()"
					aria-label="Close">
					<span aria-hidden="true">×</span>
				</button>
			</div>
			<div class="modal-body" style="background: #dbdde6">

				<table class="table table-striped" style="overflow-y: scroll;
				display: block;">
					<thead>
						<ng-container >
							<th *ngFor="let date of currentCandidate.attendence;">
								<b>{{date.date | date}}</b>
							</th>
						</ng-container>
						
					</thead>
					<tbody class="notranslate">
						<tr>

							<td *ngFor="let attendace of currentCandidate.attendence; let j=index;">
								<span
									[style.color]="statusColor[attendace.attendenceStatus?attendace.attendenceStatus: '-']">
									<b>{{attendace.attendenceStatus ? attendace.attendenceStatus:"N/A"}}</b></span><span
									*ngIf="attendace && attendace.attendenceStatus">/<b>{{attendace.eligibleCandidatePerDayDuration
										? attendace.eligibleCandidatePerDayDuration : 0}}</b></span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="modal-footer text-center">

				<button type="button" class="btn btn-primary center-btn btn-create"
					(click)="closeAttendanceModal()">Close</button>

			</div>
		</div>
	</div>
</div>